import { HTTPClient } from "@abaco/web-common/src/HTTP";

import { AccountsItem, AccountType, JohnDeereStatusObj } from "../models/AccountsModel";

export default class AccountsApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getAccountItems(pkCuaa: number): Promise<AccountsItem> {
        const res = await this.http.get(`/iot/api/v1/farm/${pkCuaa}/accounts`);
        return res.data;
    }

    public async deleteAccounts(
        pkCuaa: number,
        typeAccount: AccountType,
        account: Record<string, unknown>[]
    ): Promise<number> {
        let res = await this.http.post(`/iot/api/v1/farm/${pkCuaa}/accounts/${typeAccount}/remove`, account);
        if (typeAccount === "johnDeere" && Math.round(res.status / 100) == 2) {
            res = await this.http.delete(`/sitiagri-rest-api/api_basic/v1/mjd/subjects/${pkCuaa}`);
        }
        return res.status;
    }

    public async insertAccountItem(
        pkCuaa: number,
        account: Record<string, unknown>,
        typeAccount: string
    ): Promise<number> {
        let statusCode: number;

        try {
            const res = await this.http.post(`/iot/api/v1/farm/${pkCuaa}/accounts/${typeAccount}`, account);
            statusCode = res.status;
        } catch (error) {
            statusCode = 500;
        }

        return statusCode;
    }

    public async isJohnDeereSynced(pkCuaa: number): Promise<JohnDeereStatusObj | null> {
        const url = `/iot/api/v1/farm/${pkCuaa}/john-deere/sync/status`;
        try {
            const res = await this.http.get(url);
            return res.data;
        } catch (error) {
            return null;
        }
    }

    public async syncJohnDeere(pkCuaa: number): Promise<void> {
        const url = `/iot/api/v1/farm/${pkCuaa}/john-deere/sync`;
        const res = await this.http.post(url);
    }
}
